import { useState } from 'react';
import { AdminFormModal, ModalStage } from '../../AdminFormModal';
import { Input } from '@platform/components';
import { AdminProjects } from '@platform/client';
import { ProjectRecommendationSuccessResponse } from '@platform/client/schemas';

const ProjectRecommendationModal = (props: { projectId: number; onClose: () => void }) => {
  const { projectId, onClose } = props;
  const [modalStage, setModalStage] = useState<ModalStage>('form');
  const [professionalId, setProfessionalId] = useState<string>();
  const [professionalName, setProfessionalName] = useState<string>();
  const createRecommendationMutator = AdminProjects.useCreateProjectRecommendation({
    mutation: {
      onSuccess: (data: unknown) => {
        setProfessionalName((data as ProjectRecommendationSuccessResponse).professionalName);
        setModalStage('success');
      },
      onError: () => {
        setModalStage('error');
      },
    },
  });
  return (
    <AdminFormModal
      title={`Recommend Project: ${projectId}`}
      modalStage={modalStage}
      onClose={onClose}
      submitCTA={{
        callback: () => {
          if (professionalId) {
            createRecommendationMutator.mutate({
              data: {
                projectId,
                professionalId: parseInt(professionalId),
              },
            });
          }
        },
        text: 'Recommend Project',
        isDisabled: () => !professionalId,
      }}
      successText={`Project recommended to ${professionalName}`}
    >
      <Input
        label='Professional ID'
        type='inline'
        inputType='number'
        value={professionalId ?? ''}
        onChange={(e) => setProfessionalId(e.target.value)}
      />
    </AdminFormModal>
  );
};

export default ProjectRecommendationModal;
